<template>
  <div></div>
</template>

<script>
  import {
    sendSetMealJs,
    xiaoBaiYuanPayJs,
    PayPostAgeJs,
    addSeriesCouponOrder,
    paySpeedMember,
    sendDifferenceSetMeal,
  } from "@/api/newPay";
  import { addShopOrder } from "@/api/shopping";
  export default {
    data() {
      return {
        //回调地址
        url: "",
      };
    },
    created() {},
    mounted() {
      if (this.$route.query.appId) {
        this.wx(null, 1, this);
      } else {
        this.wx(this.$route.query.code, 0, this);
      }
    },
    methods: {
      weixinSDK(appid, timeStamp, package2, nonceStr, paySign, type) {
        function onBridgeReady() {
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appid,
              timeStamp: timeStamp,
              nonceStr: nonceStr,
              package: package2,
              signType: type,
              paySign: paySign,
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                alert("充值成功");
              } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                alert("取消充值");
              } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                alert("充值失败");
              }
            }
          );
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      },
      wx(code, type, than) {
        function jumpLink() {
          //       window.location="https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + that.appId +
          //       "&redirect_uri=" + window.location.protocol + '//' + window.location.host +
          // "&response_type=code&scope=snsapi_userinfo&state=" + time + "#wechat_redirect";''
          console.log(than.$route.query.update, "4225255552555855");

          than.url = encodeURIComponent(
            `${window.location.protocol}//${
              window.location.host
            }/appRedirect/?card=${than.$route.query.card}&payId=${
              than.$route.query.payId
            }&buttonSelection=${
              than.$route.query.buttonSelection
            }&routeAddress=${encodeURIComponent("/wap/index.html#/wechats")}`
          );

          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            than.$route.query.appId +
            "&response_type=code&scope=snsapi_userinfo&redirect_uri=" +
            than.url;
        }
        getUserInfo();
        function getUserInfo() {
          if (code != null && code != undefined && code.trim() != "") {
            than.addSeriesCouponOrder(
              than.$route.query.card,
              than.$route.query.payId,
              code,
              than.$route.query.buttonSelection
            );
          } else {
            if (type == 1) {
              jumpLink();
            }
          }
        }
      },
      //支付极速会员
      sendDifferenceSetMeal(card, meal, payId, code) {
        sendDifferenceSetMeal(card, meal, payId, code).then((res) => {
          if (res.status) {
            var obj = {};
            obj = res.data.body;
            this.weixinSDK(
              obj.appId,
              obj.timeStamp,
              obj.package,
              obj.nonceStr,
              obj.sign,
              obj.signType
            );
          } else {
            this.$toast(res.msg);
          }
        });
      },

      //支付极速会员
      paySpeedMember(payId, code) {
        paySpeedMember(payId, code).then((res) => {
          if (res.status) {
            var obj = {};
            obj = res.data.body;
            this.weixinSDK(
              obj.appId,
              obj.timeStamp,
              obj.package,
              obj.nonceStr,
              obj.sign,
              obj.signType
            );
          } else {
            this.$toast(res.msg);
          }
        });
      },

      //支付优惠券
      addSeriesCouponOrder(card, payId, code, buttonSelection) {
        addSeriesCouponOrder(card, payId, code, buttonSelection).then((res) => {
          if (res.status) {
            var obj = {};
            obj = res.data.body;
            console.log(obj);
            this.weixinSDK(
              obj.appId,
              obj.timeStamp,
              obj.package,
              obj.nonceStr,
              obj.sign,
              obj.signType
            );
          } else {
            this.$toast(res.msg);
          }
        });
      },

      //JS支付邮费
      PayPostAgeJs(code) {
        var form = JSON.parse(localStorage.getItem("addressForm"));
        form.code = code;
        PayPostAgeJs(form).then((res) => {
          if (res.status) {
            var obj = {};
            obj = res.data.body;
            console.log(obj);
            this.weixinSDK(
              obj.appId,
              obj.timeStamp,
              obj.package,
              obj.nonceStr,
              obj.sign,
              obj.signType
            );
          } else {
            this.$toast(res.msg);
          }
        });
      },
      //JS下单商品
      addShopOrder(code) {
        var shop = JSON.parse(localStorage.getItem("shopDetail"));
        addShopOrder(this.$route.query.payId, shop, code).then((res) => {
          if (res.status) {
            var obj = {};
            obj = res.data.body;
            console.log(obj);
            this.weixinSDK(
              obj.appId,
              obj.timeStamp,
              obj.package,
              obj.nonceStr,
              obj.sign,
              obj.signType
            );
          } else {
            this.$toast(res.msg);
          }
        });
      },
      //JS余额充值
      xiaoBaiYuanPayJs(code) {
        xiaoBaiYuanPayJs(
          this.$route.query.card,
          this.$route.query.balance,
          this.$route.query.payId,
          code,

          "",
          "",
          "",
          ""
        ).then((res) => {
          if (res.status) {
            var obj = {};
            obj = res.data.body;
            console.log(obj);
            this.weixinSDK(
              obj.appId,
              obj.timeStamp,
              obj.package,
              obj.nonceStr,
              obj.sign,
              obj.signType
            );
          } else {
            this.$toast(res.msg);
          }
        });
      },
      //JS充值套餐
      sendSetMealJs(code) {
        sendSetMealJs(
          this.$route.query.card,
          this.$route.query.mealId,
          this.$route.query.payId,
          code,
          this.$route.query.next,
          "",
          this.$route.query.flag,
          this.$route.query.vipId
        ).then((res) => {
          if (res.status) {
            var obj = {};
            obj = res.data.body;
            console.log(obj);
            this.weixinSDK(
              obj.appId,
              obj.timeStamp,
              obj.package,
              obj.nonceStr,
              obj.sign,
              obj.signType
            );
          } else {
            this.$toast(res.msg);
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
